<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :search="search"
      :items="transparencySubTypes"
      :loading="loading"
      item-key="name"
      class="table-rounded datatable-height"
      fixed-header
      disable-sort
    >
      <!-- name -->
      <template #[`item.name`]="{ item }">
        <div class="d-flex flex-column">
          <span class="d-block font-weight-semibold text--primary text-truncate">{{ item.name }}</span>
          <!-- <small>{{ item.post }}</small> -->
        </div>
      </template>

      <template #[`item.actions`]="{ item }">
        <div class="d-flex">
          <router-link :to="`/transparency/type/${id}/type-content/${item.id}`" class="btn-releases center-router">
            <v-icon size="22">{{ icons.mdiEyeSettings }}</v-icon>
          </router-link>
          <CrudButtons @edit="$emit('edit', item)" @remove="$emit('remove', item)"></CrudButtons>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mdiEyeSettings } from '@mdi/js'
import CrudButtons from '@/components/buttons/CrudButtons.vue'
import { loadAPIImage } from '@/utils/images'

export default {
  components: {
    CrudButtons,
  },
  props: {
    transparencySubTypes: Array,
    search: String,
    loading: Boolean,
  },
  setup(props, context) {
    const route = context.root.$route
    const { id } = route.params
    const statusColor = {
      Activo: 'primary',
      Inactivo: 'error',
    }

    const loadImage = src => {
      return loadAPIImage(src)
    }

    return {
      id,
      icons: {
        mdiEyeSettings,
      },
      loadImage,
      headers: [
        { text: 'NOMBRE', value: 'name' },
        { text: 'TIPO', value: 'type' },
        { text: 'FECHA REGISTRO', value: 'created_at' },
        { text: 'ULTIMA ACTUALIZACION', value: 'updated_at' },
        { text: '', value: 'actions', align: 'right' },
      ],
      status: {
        1: 'Activo',
        2: 'Inactivo',
        //3: 'Rechazado',
      },
      statusColor,
    }
  },
}
</script>

<style lang="scss" scoped>
.img {
  width: 150px;
  height: 150px;
  padding: 10px;
  margin: 10px;
}

.img img {
  max-width: 100px;
  max-height: 100px;
}

.center-sub-items {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
